const bodyScrollLock = require('body-scroll-lock');

import Sortable from 'sortablejs';

$(document).ready(function(){
    let $mobSelector = $('.bn_novels__body-drag-mob');

    if ($mobSelector.length) {
        function getIds()
        {
            let ids = [];
            $('.bn_novels__item').each(function(){
                ids.push($(this).attr('id'));
            });
            return ids;
        }

        Sortable.create($mobSelector.get(0), {
            handle: '.bn_novels__item-sort',
            animation: 150,
            onSort: function (evt) {
                $.post('/account/novels/sort-novels', {'ids' : getIds()}, function(data){
                    if (data.status === 1) {
                        flashNotify(data.message);
                    }
                }, 'json')

            },
        });
    }

    let $selector = $('.bn_novels__body-drag');

    if ($selector.length) {
        $selector.sortable({
            forcePlaceholderSize: true,
            update: function(){
                let table = $(this),
                    sortedIDs = table.sortable( 'toArray' );
                $.post('/account/novels/sort-novels', {'ids' : sortedIDs}, function(data){
                    if (data.status === 1) {
                        flashNotify(data.message);
                    }
                }, 'json')
            }
        }).disableSelection();
    }

    let $viewSelector = $('.bn_novels-view__body-drag');

    if ($viewSelector.length) {
        $viewSelector.sortable({
            forcePlaceholderSize: true,
            update: function(){
                let table = $(this),
                    sortedIDs = table.sortable( 'toArray' );
                $.post('/account/chapter/sort', {'ids' : sortedIDs}, function(data){
                    if (data.status === 1) {
                        flashNotify(data.message);
                    }
                }, 'json')
            }
        }).disableSelection();
    }

    let $mobViewSelector = $('.bn_novels-view__body-drag-mob');

    if ($mobViewSelector.length) {
        function getViewIds()
        {
            let ids = [];
            $('.bn_novels-view__chapters-row').each(function(){
                ids.push($(this).attr('id'));
            });
            return ids;
        }

        Sortable.create($mobViewSelector.get(0), {
            handle: '.bn_novels-view__chapters-sort',
            animation: 150,
            onSort: function (evt) {
                $.post('/account/chapter/sort', {'ids' : getViewIds()}, function(data){
                    if (data.status === 1) {
                        flashNotify(data.message);
                    }
                }, 'json')

            },
        });
    }

    let $tagsSelector = $('.bn_novels-edit__form-tags');

    if ($tagsSelector.length) {
        $tagsSelector.selectize({
            plugins: ['remove_button'],
            maxItems: 3,
            delimiter: ',',
            persist: false,
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            create: true,
            load: function (query, callback) {
                if (!query.length) return callback();
                $.post('/site/search-tag-by-lang', {"str": query, 'lang':$('.bn_novels-edit__form-lang').val()}, function (data) {
                    $.each(data, function (index, item) {
                        item.id = item.name;
                    });
                    callback(data);

                }, 'JSON');
            },
            onChange: function (val) {
                $('.bn_novels-edit__form-tags-id').val(val);
            }
        });
    }

    $(".bn_novels-view__nickname-popup-form").on('beforeSubmit', function(e) {
        e.preventDefault();

        let that = $(this),
            button = that.find('.bn_novels-view__nickname-popup-submit');

        $.ajax({
            'url': '/account/profile/save-nickname',
            'type': 'POST',
            'dataType': 'json',
            'data': that.serialize(),
            'success': function (data) {
                that.find('.form-group').removeClass('has-error');
                that.find('.help-block-error').html('');

                if (data.errors != undefined) {
                    $.each(data.errors, function (index, arrErrors) {
                        $.each(arrErrors, function (index1, error) {
                            $('#' + index).closest('.form-group').addClass('has-error');
                            $('#' + index).closest('.form-group').find('.help-block-error').html(error);
                        });
                    })

                    button.removeAttr('disabled')
                    button.removeClass('spin');
                } else {
                    closePopup('.bn_novels-view__popup.nickname')

                    flashNotify(data.message)
                }
            }
        });
    }).on('submit', function(e){
        e.preventDefault();
    });
});

$(document).on('input', '.bn_novels__search-input', function () {
    let that = $(this),
        value = $.trim(that.val()).toLowerCase(),
        items = $('.bn_novels__item'),
        empty = $('.bn_novels__search-empty'),
        wrapper = $('.bn_novels__wrapper');

    items.removeClass('hidden');

    if (value.length > 0) {
        items.each(function (index, item) {
            let title = $(item).find('.bn_novels__item-title').text();

            if (title.toLowerCase().includes(value)) {
                $(item).removeClass('hidden')
            } else {
                $(item).addClass('hidden')
            }
        })
    }

    if (items.not('.hidden').length === 0) {
        empty.show();
        wrapper.hide();
    } else {
        wrapper.show();
        empty.hide();
    }
})

$(document).on('click', '.bn_novels__item-controls-menu-button', function () {
    let that = $(this),
        container = that.parents('.bn_novels__item-controls-menu'),
        menu = container.find('.bn_novels__item-controls-menu-dropdown'),
        menuDom = menu.get(0);

    menu.removeClass('position-top');

    $('.bn_novels__item-controls-menu-button').not(that).parents('.bn_novels__item-controls-menu').removeClass('open');

    container.toggleClass('open')

    if (window.innerHeight - menuDom.getBoundingClientRect().bottom < 10) {
        menu.addClass('position-top')
    }

    $(document).on('click', function (event) {
        if ($(event.target).closest('.bn_novels__item-controls-menu-button, .bn_novels__item-controls-menu-dropdown').length) return;

        $('.bn_novels__item-controls-menu').removeClass('open');
    });
});

$(document).on('click', '.novels-open-popup', function () {
    openPopup('.bn_novels-view__popup.blocked');
})

$(document).on('click', '.novels-open-edit-popup', function () {
    openPopup('.bn_novels-view__popup.edit');
})

$(document).on('click', '.novels-open-edit-popup', function () {
    openPopup('.bn_novels-view__popup.edit');
})

function openPopup(selector) {
    let wrapper = $(selector),
        element = wrapper.find('.bn_novels-view__popup-scroll').get(0),
        overlay = wrapper.find('.bn_novels-view__popup-overlay');

    bodyScrollLock.disableBodyScroll(element, {reserveScrollBarGap: true});

    overlay.addClass('open');

    $('body').addClass('modal-open');
}

function closePopup () {
    $('.bn_novels-view__popup-overlay').removeClass('open');

    bodyScrollLock.clearAllBodyScrollLocks();

    $('body').removeClass('modal-open');
}

$(document).on('click', '.bn_novels-view__chapters-sort-mobile', function () {
    let that = $(this);

    that.toggleClass('invert');

    that.parents('.bn_novels-view__chapters').find('.bn_novels-view__chapters-body').toggleClass('invert');
})

$(document).on('click', '.novels-close-popup', function () {
    closePopup();
});

$(document).on('click', '.bn_novels-view__popup-overlay', function (event) {
    if ($(event.target).closest('.bn_novels-view__popup-wrapper').length) return;

    if (!$(this).hasClass('open')) return;

    if ($(this).parents('.bn_novels-view__popup').hasClass('nickname')) return;

    closePopup();
});

window.bookCycleIdOnChange = function () {
    var cycle_id = $('#bookeditform-cycle_id').val();
    if (cycle_id > 0) {
        let i = 0;

        $('#bookeditform-priority_cycle').prop('disabled', false);
        if (cycle_books_count[cycle_id] != undefined) {
            $('#bookeditform-priority_cycle option[value!=""]').remove();
            for (i = 0; i < parseInt(cycle_books_count[cycle_id]) + 1; i++) {
                $('#bookeditform-priority_cycle').append($("<option />").val(i + 1).text(i + 1));
            }
        }

    } else {
        $('#bookeditform-priority_cycle').val('');
        $('#bookeditform-priority_cycle').prop('disabled', true);
    }

    $('#bookeditform-priority_cycle').parents('.custom-dropdown').find('.custom-dropdown__select').remove();
    $('#bookeditform-priority_cycle').parents('.custom-dropdown').find('.custom-dropdown__options').remove();
    $('#bookeditform-priority_cycle').parents('.custom-dropdown').removeClass('custom-dropdown');

    initCustomDropdown();
};

window.openNicknamePopup = function() {
    openPopup('.bn_novels-view__popup.nickname')
};
